import { create } from 'zustand';
import type { AdminUser } from '@repo/shared-types';

const TOKEN_KEY = 'lophoc_admin_access_token';
const REFRESH_KEY = 'lophoc_admin_refresh_token';
const USER_KEY = 'lophoc_admin_user';

interface AdminAuthState {
  user: AdminUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  isLoading: boolean;
  setAuth: (d: { user: AdminUser; tokens: { accessToken: string; refreshToken: string } }) => void;
  updateTokens: (t: { accessToken: string; refreshToken: string }) => void;
  clearAuth: () => void;
  setLoading: (v: boolean) => void;
  hydrateFromStorage: () => boolean;
}

export const useAdminAuthStore = create<AdminAuthState>((set) => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  isLoading: true,
  setAuth: ({ user, tokens }) => {
    localStorage.setItem(TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(REFRESH_KEY, tokens.refreshToken);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ user, accessToken: tokens.accessToken, refreshToken: tokens.refreshToken, isLoading: false });
  },
  updateTokens: (t) => {
    localStorage.setItem(TOKEN_KEY, t.accessToken);
    localStorage.setItem(REFRESH_KEY, t.refreshToken);
    set({ accessToken: t.accessToken, refreshToken: t.refreshToken });
  },
  clearAuth: () => {
    [TOKEN_KEY, REFRESH_KEY, USER_KEY].forEach((k) => localStorage.removeItem(k));
    set({ user: null, accessToken: null, refreshToken: null, isLoading: false });
  },
  setLoading: (isLoading) => set({ isLoading }),
  hydrateFromStorage: () => {
    const accessToken = localStorage.getItem(TOKEN_KEY);
    const refreshToken = localStorage.getItem(REFRESH_KEY);
    const rawUser = localStorage.getItem(USER_KEY);
    if (!accessToken || !refreshToken) {
      set({ isLoading: false });
      return false;
    }
    set({
      accessToken,
      refreshToken,
      user: rawUser ? (JSON.parse(rawUser) as AdminUser) : null,
      isLoading: false,
    });
    return true;
  },
}));
